module.exports = __webpack_public_path__ + "static/media/Newsletter-Sep.f83ea2ca.pdf";